import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

function useCountdown(target) {
  const [t, setT] = useState(() => Math.max(0, new Date(target) - new Date()));
  useEffect(() => {
    const id = setInterval(() => setT(Math.max(0, new Date(target) - new Date())), 1000);
    return () => clearInterval(id);
  }, [target]);
  const h = Math.floor(t / 3600000);
  const m = Math.floor((t % 3600000) / 60000);
  const s = Math.floor((t % 60000) / 1000);
  return { h, m, s };
}

export default function TrialTripwire({ leak, onCancel, onRefund }) {
  const { h, m, s } = useCountdown(leak.trial_ends_at || leak.next_charge_at);
  const day = Math.floor(h / 24);
  const dispH = h % 24;
  return (
    <Card
      className="relative overflow-hidden rounded-md p-4 sm:p-5 grain"
      style={{
        borderColor: "rgba(255,61,0,0.4)",
        boxShadow: "0 0 40px rgba(255,61,0,0.12)",
        background: "linear-gradient(135deg, #1a0e08 0%, #141618 100%)",
      }}
      data-testid="trial-tripwire"
    >
      <div className="flex items-start sm:items-center justify-between gap-4 flex-col sm:flex-row">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 grid place-items-center rounded-md bg-[#FF3D00]/15 border border-[#FF3D00]/40">
            <AlertTriangle className="h-5 w-5 text-[#FF3D00]" />
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-[#FF3D00]">TRIAL TRIPWIRE</div>
            <div className="font-display font-bold text-lg tracking-tight mt-0.5">
              {leak.merchant} trial converts in{" "}
              <span className="tabular-nums text-[#FF3D00]" data-testid="trial-countdown">
                {day > 0 && `${day}d `}{String(dispH).padStart(2,'0')}h {String(m).padStart(2,'0')}m {String(s).padStart(2,'0')}s
              </span>
            </div>
            <div className="text-sm text-[#A0A7B0] mt-1">
              ${leak.amount.toFixed(2)} charge incoming. Kill it now — keep the remaining trial days.
            </div>
          </div>
        </div>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" onClick={onRefund} className="btn-outline-paper" data-testid="trial-refund-button">
            Draft refund
          </Button>
          <Button className="btn-emerald" onClick={onCancel} data-testid="trial-cancel-button">
            Cancel now
          </Button>
        </div>
      </div>
    </Card>
  );
}
